import dayjs from 'dayjs';

export const DEFAULT_DATE = {
  timeType: 'static',
  timeDimension: 'day',
  startTime: dayjs().subtract(7, 'day').format('YYYYMMDD'),
  endTime: dayjs().subtract(1, 'day').format('YYYYMMDD'),
};

export const DEFAULT_IS_CALC_TODAY_OPTIONS = [
  { value: 1, label: '是' },
  { value: 0, label: '否' },
];

export const DEFAULT_TIME_UNIT_OPTIONS = [
  { value: 'day', label: '天' },
  { value: 'week', label: '周' },
  { value: 'month', label: '月' },
];

export const DEFAULT_IS_RETENTION_OPTIONS = [
  { value: 1, label: '留存' },
  { value: 0, label: '流失' },
];

export const DEFAULT_CHART_SHOW_TYPE_OPTIONS = [
  { value: 1, label: '趋势' },
  { value: 2, label: '对比' },
];

export const DEFAULT_GROUP_PROPERTY_TYPE_OPTIONS = [
  { value: -1, label: '总体' },
  { value: 1, label: '事件属性' },
  { value: 2, label: '用户属性' },
];

export const DEFAULT_TIME_UNIT_ENUM = {
  day: '天',
  week: '周',
  month: '月',
};
